import React from 'react';
import { Shield, Clock, Award, Users } from 'lucide-react';
import { motion, useMotionValue, useTransform, animate } from 'framer-motion';

const Counter = ({ value }) => {
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) => Math.round(latest));

  React.useEffect(() => {
    const controls = animate(count, value, { duration: 0.5 });
    return controls.stop;
  }, [value, count]);

  return <motion.span>{rounded}</motion.span>;
};

const About = () => {
  const stats = [
    { icon: Clock, label: 'Etableret', value: '2017' },
    { icon: Award, label: 'Kvalitet', value: '100%' },
    { icon: Shield, label: 'Garanti', value: 'Sikret' },
    { icon: Users, label: 'Kunder', value: '500+' },
  ];

  return (
    <section id="om-os" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          <div className="lg:w-1/2 relative">
            <div className="relative z-10 overflow-hidden shadow-2xl">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/10d78498-60e6-4cb8-8f48-f81fe0e15f7b/img-5826.jpeg"
                alt="Traditionelt flise- og murerarbejde"
                className="w-full h-auto"
              />
            </div>
            {/* Decorative background elements */}
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-orange-600/10 rounded-full blur-2xl"></div>
            <div className="absolute -bottom-10 -right-10 w-64 h-64 bg-orange-600/5 rounded-full blur-3xl"></div>
            <div className="absolute bottom-10 left-10 bg-white p-6 shadow-xl z-20 hidden md:block">
              <p className="text-black font-bold text-4xl mb-1">
                <Counter value={25} />
              </p>
              <p className="text-slate-600 text-sm font-medium uppercase tracking-wider">Års erfaring</p>
            </div>
          </div>

          <div className="lg:w-1/2">
            <h2 className="text-orange-600 font-bold tracking-wider uppercase text-sm mb-3">Om SL. Flise & Murer</h2>
            <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 leading-tight">
              Flise- & murerarbejde med fokus på detaljen
            </h3>
            <p className="text-slate-600 mb-6 leading-relaxed">
              SL. Flise- og murerforretning blev etableret i 2017, men vores erfaring i murerfaget strækker sig helt tilbage til 2001. Med ca. 25 års erfaring leverer vi murerarbejde af højeste kvalitet til private og erhverv i Tønder og omegn. Vi bygger på stolte traditioner, hvor det gode håndværk og kundens tilfredshed altid kommer i første række.
            </p>
            <p className="text-slate-600 mb-10 leading-relaxed">
              Vi er specialister i alt fra klassisk murerarbejde samt flise- og klinkearbejde til renoveringer og reparationer. Uanset opgavens størrelse går vi til værks med samme professionalisme og præcision.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="inline-flex items-center justify-center mb-4 text-black">
                    <stat.icon className="h-6 w-6" />
                  </div>
                  <p className="text-2xl font-bold text-slate-900">{stat.value}</p>
                  <p className="text-xs text-slate-500 font-medium uppercase tracking-wide">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
